import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Icon from "../Icon";
import { Link } from "react-router-dom";
import { ReactComponent as DarkIllustration } from '../../assets/dark-front.svg';
import { ReactComponent as Lightllustration } from '../../assets/light-front.svg';
import SVGAnimate from '../../SVGAnimate';
import { useIntl } from 'react-intl';

const SectionList = ({ main, mode, toogleMode }) => {
    const intl = useIntl();

    const [settings, setSettings] = useState(null);
    const [selected, setSelected] = useState(null);
    const [opened, setOpened] = useState(null);
    const [selectedCategor, setSelectedCategor] = useState(null);

    const [hoverElement, setHoverElement] = useState(null)
    const mouseOut = (element) => {
        if (hoverElement === element) {
            setHoverElement(null);
        }
    }

    const isOpen = (section) => {
        if (opened === section.title) {
            return true;
        }
        return false;
    }

    const closeMenu = ()  => {
        setOpened(null)
        setSelected(null);
        setSelectedCategor(null);
    }

    const GetArchiveLink = (section) => {
        return <>
        <div className="separator"></div>
        <Link to={`/archivum/${section.url}`}
                className={`categor-item archivum ${(selectedCategor&& selectedCategor.type && selectedCategor.type === "archive") || hoverElement === section? mode==="dark" ? (selected.url+' theme-color'):"": ""}`}
                onMouseOver={() => setSelectedCategor({type: "archive", lead: " ", title: " "})}
                onMouseLeave={() => setSelectedCategor(null)}
                xs={12}>
                <Icon icon="archive-fill" className={(selectedCategor&&selectedCategor.type && selectedCategor.type === "archive")  ? mode!=="dark"?"white":"theme-color" : ""}/> Archívum
                {(selectedCategor&&selectedCategor.type && selectedCategor.type === "archive")  && <div className={`hover-icon ${selected && selected.url}`}><Icon icon="arrow-right" className={`${mode!=="dark"?"white":"theme-color"}  categor-arrow-right`} /></div>}
            </Link>
            </>
    }
    const GetSimpleArchiveLink = (section) => {
        return <>
        <div className="separator"></div>
        <Link to={`/archivum/${section.url}`}>
                <Icon icon="archive-fill" className={selectedCategor === section ? mode!=="dark"?"white":"theme-color" : ""}/> Archívum
                {selectedCategor === section && <div className={`hover-icon ${selected && selected.url}`}><Icon icon="arrow-right" className={`${mode!=="dark"?"white":"theme-color"}  categor-arrow-right`} /></div>}
            </Link>
            </>
    }

    const GetCategor = (categor) => {
        return (
            <Link to={categor.enabled?`/kiadvany/${categor.htmlname}`:""} className={`${(!categor.enabled?"disabled":"")} categor-item  ${selectedCategor === categor || hoverElement === categor? mode==="dark" ? (selected.url+' theme-color'):"": ""}`}
                    onMouseOver={() => setSelectedCategor(categor)}
                    onMouseLeave={() => setSelectedCategor(null)}
                    //onClick={() => setSelectedCategor(categor)}
                    xs={12}>
                    <Icon icon={categor.icon} className={selectedCategor === categor ? mode!=="dark"?"white":"theme-color" : ""} /> {categor.title}
                    {selectedCategor === categor && <div className={`hover-icon ${selected && selected.url}`}>
                        <Icon icon="arrow-right" className={`${mode!=="dark"?"white":"theme-color"} categor-arrow-right`} />
                    </div>}
            </Link>)
    }

    const getSimpleCategor = (categor) => {
        return (
            <Link to={categor.enabled?`/kiadvany/${categor.htmlname}`:""} className={!categor.enabled?"disabled":""}>
                    <Icon icon={categor.icon} className={selectedCategor === categor ? mode!=="dark"?"white":"theme-color" : ""} /> {categor.title}
                    {selectedCategor === categor && <div className={`hover-icon ${selected && selected.url}`}><Icon icon="arrow-right" className={`${mode!=="dark"?"white":"theme-color"} categor-arrow-right`} /></div>}
            </Link>)
    }


    const changeOpen = (section) => {
        if (isOpen(section)) {
            closeMenu();
            return false;
        }
        setOpened(section.title)
        setSelected(section);
        setSelectedCategor(null);
    }

    useEffect(() => {
        SVGAnimate()
    },[])

    useEffect(() => {
        setSettings(main);
    }, [main])
    return (<>
    <div id="illustration">
        {mode==="dark"&&<DarkIllustration />}
        {mode !== "dark"&&<Lightllustration />}
    </div>
        {settings && settings.sections &&
            <Row className={`align-items-start ${opened?"open":""}`}>
                <Col
                    lg={6} md={12} className="sections"  >
                    <Row className="left-section">
                        <Col xs={12} className="title">
                            <h1 dangerouslySetInnerHTML={{ __html: settings.title+'<a href="https://ksh.hu?lang=' + intl.locale + '"><img src="'+intl.formatMessage({ id: 'hcso_logo_head.url', defaultMessage: 'assets/logo.svg' })+'" alt="'+intl.formatMessage({ id: 'hcso_logo_head.alt', defaultMessage: 'KSH logo' })+'" /></a>'}}>

                                </h1>
                                </Col>
                        {settings.sections.map(section => (<>
                            <Col xs={12}
                                onMouseEnter={() => setHoverElement(section.title)}
                                onMouseLeave={() => mouseOut(section.title)}
                                className={`section ${(!selected || selected.title !== section.title) && hoverElement !== section.title ? "bg-"+section.url: "bg-"+section.url + (mode!=="dark"?"-s":" theme-color "+ section.url)} ${selected && selected.title === section.title && 'open'}`}
                                //onMouseOver={() => changeOpen(section)}
                                onClick={() => changeOpen(section)}
                            >
                                {section.title}
                                {(!selected || selected.title !== section.title) && <Icon icon="plus-lg" className={`right ${hoverElement === section.title && "theme-color"}`} />}
                                {selected && selected.title === section.title && <>
                                <Icon icon="arrow-right" className={`right d-none d-lg-block d-xl-block`} />
                                <Icon icon="close" className={`right d-block d-lg-none d-xl-none`} />
                                </>}
                            </Col>
                            {selected && selected.title === section.title && <div
                                className={`mobil-categories bg-${section.url}${(mode!=="dark"?"-s":" theme-color "+ section.url)} d-block d-lg-none d-xl-none`}
                                >
                                {section.categories.map(categor => getSimpleCategor(categor))}
                                {GetSimpleArchiveLink(selected)}
                                </div>
                                }
                        </>
                        ))}
                        {selectedCategor &&
                            <Col xs={12} xl={10} id="selected-categor" className=" d-lg-block d-xl-block">
                                <h3>{selectedCategor.title}</h3>
                                {selectedCategor.lead&&<div dangerouslySetInnerHTML={{ __html: selectedCategor.lead }}></div>}
                            </Col>
                        }
                        {!selectedCategor&&<Col  xs={12} lg={10} id="selected-categor" dangerouslySetInnerHTML={ {__html: main.fronttext || ""}}>
                            </Col>}
                    </Row>
                    <Col sm={2} md={3} lg={2} className="bottom align-self-end right"
                                    >
                            {mode&&mode==="dark"&&<button  onClick={toogleMode}><Icon icon="sun" className="white"/> Light mode</button>}
                            {mode&&mode!=="dark"&&<button onClick={toogleMode}><Icon icon="moon" className="white"/> Dark mode</button>}
                    </Col>
                </Col>
                    <Col lg={6} md={12} className={`categors bg-${(selected && selected.url) || 'none'}${mode==="dark"?"":"-s"} d-none  d-lg-block d-xl-block`}
                    >
                        {selected && <div  className={`bg-${selected.url+(mode!=="dark"?"-s":"")} categors-items`} >

                                {selected.categories.map(categor => (
                                    GetCategor(categor)
                                ))}
                                {selected.categories.some(x => x.archivumlink) ? GetArchiveLink(selected) : null}

                            </div>}
                    </Col>
            </Row >
        }

    </>)
}

export default SectionList;
